import { useState, useEffect } from 'react'
import { TreeSelect } from 'mk-pc'
import { getNavList } from '@/features/nav'
import './index.scss'

interface Props {
  title?: string
  value?: string | Array<string>
  style?: any
  onChange?: (e: string) => void
}

/**
 * 部门选择
 */
export const NavSelector = ({ title, value = undefined, ...props }: Props) => {
  const [list, setList] = useState([] as any)

  useEffect(() => {
    fetchData()
  }, [])

  /**
   * 获取部门列表
   * @returns
   */
  const fetchData = () => {
    getNavList()
      .then((res: any) => {
        setList(genNavTree(res || [], ''))
      })
      .catch(() => {
        setList([])
      })
  }

  /**
   * 生成导航树
   * @param list
   * @param parentId
   * @returns
   */
  const genNavTree = (list: Array<any>, parentId: string = ''): Array<any> => {
    const children = [] as Array<any>

    list
      .filter((n: any) => n.parentId === parentId)
      .forEach((n: any) => {
        children.push({
          id: n.id,
          name: n.name,
          parentId: parent ? parentId : n.id,
          parentIds: n.parentIds,
          children: genNavTree(list, n.id)
        })
      })

    return children
  }

  return (
    <TreeSelect
      {...props}
      value={value || undefined}
      placeholder="选择导航"
      style={{ width: '100%' }}
      fieldNames={{ label: 'name', value: 'id' }}
      dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
      allowClear
      treeDefaultExpandAll
      treeData={list}
    />
  )
}
